import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('VisualExercise', 'v0');
export default exerciseTypeVersionAdapter;